module.exports = __webpack_public_path__ + "static/media/success-animation.df5908ac.lottie";